import { detectPwaInstallEnvironment, type PwaPlatform } from '@/lib/pwa';

// Fiches magasin de l'app native (chantier stores, iOS publiée le 09/09/2026).
// Une URL vide = l'app n'est pas encore publique sur cette plateforme : la
// webapp continue alors de proposer l'installation PWA, rien ne change pour
// ces personnes. Tout ce qui s'appuie sur ces liens est réservé à la webapp,
// jamais à l'app native elle-même (voir les gardes isNativeApp côté appelants).
export const IOS_APP_STORE_ID = '6806544227';
export const IOS_APP_STORE_URL = 'https://apps.apple.com/fr/app/liberio/id6806544227';
// Google Play : app Android publique depuis septembre 2026.
export const ANDROID_PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=app.liberio.mobile';
// Compte App Store Connect de Liberio : sans ce jeton, Apple ne rattache aucun
// téléchargement à la campagne `ct`.
const APP_STORE_PROVIDER_TOKEN = '129375946';

// La webapp ne peut pas savoir si l'app a été installée : on retient le tap
// vers la fiche, qui coche le point de la checklist et retire la carte.
export const NATIVE_APP_DOWNLOAD_CLICKED_AT_KEY = 'liberio_native_app_download_clicked_at';
export const NATIVE_APP_CARD_DISMISSED_AT_KEY = 'liberio_native_app_card_dismissed_at';

export function nativeStoreUrlFor(platform: PwaPlatform): string {
  if (platform === 'ios') {
    return IOS_APP_STORE_URL;
  }
  if (platform === 'android') {
    return ANDROID_PLAY_STORE_URL;
  }
  return '';
}

// Lien de fiche étiqueté par canal, pour compter les téléchargements venus de
// chaque bouton : `ct` pour App Store Connect (Analytics > Campagnes), le
// paramètre `referrer` pour Google Play (Acquisition, UTM).
// Apple masque toute campagne sous 5 téléchargements : un détail trop fin (une
// boutique) y disparaîtrait, d'où `iosChannel` pour regrouper côté iPhone.
export function trackedNativeStoreUrl(
  platform: PwaPlatform,
  channel: string,
  options: { iosChannel?: string; source?: string; medium?: string } = {},
): string {
  const base = nativeStoreUrlFor(platform);
  if (!base) {
    return '';
  }
  const url = new URL(base);
  if (platform === 'ios') {
    url.searchParams.set('pt', APP_STORE_PROVIDER_TOKEN);
    url.searchParams.set('ct', (options.iosChannel ?? channel).slice(0, 40));
    url.searchParams.set('mt', '8');
  } else {
    url.searchParams.set(
      'referrer',
      new URLSearchParams({
        utm_source: options.source ?? 'webapp',
        utm_medium: options.medium ?? 'referral',
        utm_campaign: channel,
      }).toString(),
    );
  }
  return url.toString();
}

// Téléphone Android dans un navigateur : les textes disent alors Google Play
// au lieu de l'App Store.
export function isAndroidBrowser(): boolean {
  if (typeof navigator === 'undefined') {
    return false;
  }
  return detectPwaInstallEnvironment(navigator.userAgent).platform === 'android';
}
